import { countryMapToShortened } from 'shared/core/constants/geography';

const buildproductJsonLd = (productData) => {
  const { name, Image, description, brand, url, recPrices, location } = productData;
  let { price } = productData;

  if (!price && recPrices?.length) {
    [price] = recPrices;
  }

  const data = {
    '@context': `http://schema.org`,
    '@type': `Product`,
    description,
    name,
    image: Image,
    offers: {
      '@type': `Offer`,
      availability: 'https://schema.org/InStock',
      price,
      priceCurrency: 'USD', // TODO: make this work for CA
      url,
    },
  };

  if (brand?.name?.length) {
    data.brand = {
      name: brand.name,
      description: brand.description,
      logo: brand.imageUrl,
    };
  }

  if (location) {
    const { ln1, ln2, city, state, country } = location;
    data.offers.availableAtOrFrom = {
      '@type': `Place`,
      address: {
        '@type': `PostalAddress`,
        streetAddress: [ln1, ln2].filter(Boolean).join(' '),
        addressLocality: city,
        addressRegion: state,
        addressCountry: countryMapToShortened[country] || country,
      },
    };
  }

  return data;
};

export default buildproductJsonLd;
